"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "limbadi": {
    "766d6285": [{
      "hkey": "9f5fc606",
      "slug": "limbadi-caroni",
      "name": "Limbadi-Caroni",
      "primary": true,
      "skipSearch": false
    }],
    "caroni": [{
      "hkey": "9f5fc606",
      "slug": "limbadi-caroni",
      "name": "Limbadi-Caroni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9f6e6282": [{
      "hkey": "c41de0cb",
      "slug": "limbadi",
      "name": "Limbadi",
      "primary": true,
      "skipSearch": false
    }],
    "localita-badia": [{
      "hkey": "c41de0cb",
      "slug": "limbadi",
      "name": "Limbadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e189329b": [{
      "hkey": "f83fd22b",
      "slug": "san-nicola-delegistis",
      "name": "San Nicola Delegistis",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola-de-legistis": [{
      "hkey": "f83fd22b",
      "slug": "san-nicola-delegistis",
      "name": "San Nicola Delegistis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;